/*
 * ResetPage Messages
 *
 * This contains all the text for the ResetPage container.
 */

import { defineMessages } from 'react-intl';

export const scope = 'app.containers.ResetPage';

export default defineMessages({
  header: {
    id: `${scope}.header`,
    defaultMessage: 'Đặt lại mật khẩu',
  },
  yourPasswordIsReset: {
    id: `${scope}.yourPasswordIsReset`,
    defaultMessage: 'Mật khẩu của bạn đã được đặt lại!',
  },
  confirmPasswordNotCorrect: {
    id: `${scope}.confirmPasswordNotCorrect`,
    defaultMessage: 'Xác nhận mật khẩu không đúng!',
  },
  plsInputPassword: {
    id: `${scope}.plsInputPassword`,
    defaultMessage: 'Vui lòng nhập mật khẩu',
  },
  plsInputConfirmPassword: {
    id: `${scope}.plsInputConfirmPassword`,
    defaultMessage: 'Vui lòng nhập xác nhận mật khẩu',
  },
  passwordLengthError: {
    id: `${scope}.passwordLengthError`,
    defaultMessage: 'Mật khẩu phải từ 8-20 ký tự!',
  },
  password: {
    id: `${scope}.password`,
    defaultMessage: 'Mật khẩu',
  },
  confirmPassword: {
    id: `${scope}.confirmPassword`,
    defaultMessage: 'Xác nhận mật khẩu',
  },
});
